import angular from 'angular';
import { MeurhMudancaHorarioService } from './mudancahorario.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhMudancaHorarioListRouting = ['$stateProvider', function ($stateProvider: angular.ui.IStateProvider) {
    const resolve = {
        'entity': [
            'MeurhMudancaHorarioService',
            'ListagemService',
            '$rootScope',
            '$stateParams',
            '$state',
            '$q',
            function (
                entityService: MeurhMudancaHorarioService,
                listagemService: ListagemService,
                $rootScope: angular.IRootScopeService & {
                    session: any,
                    liberadoTela: (arg: string) => boolean
                },
                $stateParams: angular.ui.IStateParamsService,
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if ($rootScope.liberadoTela('LIBERAR_CALENDARIO_HORARIO')) {
                    return $q<void>(() => $state.go('dp'));
                }

                if (!$stateParams['solicitacao']) {
                    return $q<void>(() => $state.go('meurh_mudancahorario'));
                }

                return entityService.get($stateParams['solicitacao'])
                    .then((data) => {
                        const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                        const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                        const mesmoEstabelecimento = data.estabelecimentoobj.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                        const deveRedirecionar = (
                            (visibilidadeLiberada && !empresaNoGrupo) ||
                            (!visibilidadeLiberada && !mesmoEstabelecimento)
                        );

                        if (deveRedirecionar) {
                            return $q(() => $state.go('meurh_mudancahorario'));
                        }

                        return data;
                    })
                    .catch((error) => {
                        if (error.status === 404) {
                            return $q(() => {
                                if ($state.href('meurh_solicitacoesmudancahorario_not_found', $stateParams)) {
                                    $state.go('meurh_solicitacoesmudancahorario_not_found', $stateParams);
                                } else {
                                    $state.go('not_found', $stateParams);
                                }
                            });
                        }

                        return $q.reject(error);
                    });
            }
        ]
    };

    $stateProvider
        .state('meurh_mudancahorario', {
            url: '/solicitacoes/mudancahorario?q',
            template: require('html-loader!./index/mudancahorario.index.html'),
            controller: 'Meurh\MudancaHorarioIndexController',
            controllerAs: 'mrh_mdnchr_lst_cntrllr',
            reloadOnSearch: false
        })
        .state('meurh_mudancahorario_new', {
            parent: 'meurh_mudancahorario',
            url: '/new',
            template: require('html-loader!./new/mudancahorario.new.html'),
            controller: 'MeurhMudancaHorarioNewController',
            controllerAs: 'mrh_mdnchr_frm_nw_cntrllr'
        }).state('meurh_mudancahorario_show', {
            parent: 'meurh_mudancahorario',
            url: '/show/:solicitacao?path',
            resolve,
            template: require('html-loader!./show/mudancahorario.show.html'),
            controller: 'MeurhMudancaHorarioShowController',
            controllerAs: 'mrh_mdnchr_frm_shw_cntrllr'
        });
    }
];
